import { defineStore, storeToRefs } from 'pinia'
import appConfig from '~~/app.config.value'
import { useIGMainStore } from '~~/modules/nuxt3-module-ingang/stores/main'

const { appId } = appConfig

export const useMainStore = defineStore(`${appId}-main`, () => {
  const parent = useIGMainStore()
  const refs = storeToRefs(parent)
  return {
    ...refs
  }
})